"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostWorkspaceSecretRequest = void 0;
var PostWorkspaceSecretRequest_1 = require("./PostWorkspaceSecretRequest");
Object.defineProperty(exports, "PostWorkspaceSecretRequest", { enumerable: true, get: function () { return PostWorkspaceSecretRequest_1.PostWorkspaceSecretRequest; } });
